import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';
import Button from 'components/common/Button';
import LogoutButton from 'components/Credit24/Core/PageHeader/LogoutButton';
import LanguageSwitcher from 'components/Credit24/Core/PageHeader/LanguageSwitcher';
import { getRootURL } from 'utils/helpers';

const propTypes = {
  showLoginButton: PropTypes.bool,
  params: PropTypes.object,
  navigateToLogin: PropTypes.func,
  country: PropTypes.string,
};

const defaultProps = {
  params: {},
  navigateToLogin: () => {
  },
  country: COUNTRY,
};

const PageHeader = (props) => {
  const { params, showLoginButton, navigateToLogin } = props;
  const intl = useIntl();

  const headerStyles = {};
  let logo = null;
  let logoutButtonType;

  if (EMBEDDED) {
    if (params.inline) {
      logoutButtonType = 'third';
    } else {
      logo = (
        <span
          className="page-header__logo hide-text"
          style={{ backgroundImage: `url(${params.logoUrl})` }}
        />
      );
      if (params.headerBackgroundColor) {
        headerStyles.backgroundColor = params.headerBackgroundColor;
      }
    }
  } else {
    const link = getRootURL(intl.locale, props.country);
    logo = <a href={link} className={`page-header__logo page-header__logo--${COUNTRY} hide-text`}>Credit 24</a>;
  }

  const headerClasses = cx({
    'page-header': true,
    'page-header--embedded-popup': EMBEDDED && !params.inline,
    'page-header--embedded-inline': EMBEDDED && params.inline,
  });

  return (
    <header className={headerClasses} style={headerStyles}>
      <div className="container clearfix">
        {logo}
        <LogoutButton
          {...props}
          type={logoutButtonType}
        />
        {(COUNTRY === 'EE' || COUNTRY === 'LV')
          && <LanguageSwitcher />}
        {showLoginButton
          && (
            <Button
              btnType="secondary"
              className="pull-right"
              tag="link"
              to="login"
              onClick={navigateToLogin}
            >
              <FormattedMessage id="login.buttons.login" />
            </Button>
          )}
      </div>
    </header>
  );
};

PageHeader.propTypes = propTypes;
PageHeader.defaultProps = defaultProps;

export default PageHeader;
